import { get } from 'lodash';
import { List, useTranslate, WithListContext } from 'react-admin';
import { CustomBreadcrumbs } from '../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../layouts/dashboard';
import { paths } from '../../../../routes/paths';
import { StaticConfigForm } from './StaticConfigForm';

function CustomList() {
  const translate = useTranslate();

  return (
    <DashboardContent
      sx={{
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
        paddingTop: '0 !important',
      }}
    >
      <CustomBreadcrumbs
        heading={translate('resource.staticConfig')}
        links={[
          { name: `${translate('resource.game')}`, href: paths.dashboard.game.root },
          { name: `${translate('resource.staticConfig')}` },
        ]}
        sx={{ mb: { xs: 3, md: 5 } }}
      />
      <List
        pagination={false}
        actions={false}
        sx={{
          marginTop: '-8px !important',
          pr: 2,
          '& .RaList-actions': {
            marginBottom: '5px',
          },
        }}
      >
        <p
          style={{
            color: 'var(--palette-text-secondary)',
            fontSize: '0.75rem',
            margin: '0',
            paddingLeft: '14px',
          }}
        >
          {translate('module.staticConfig.staticConfigSetBySA')}
        </p>
        <WithListContext
          render={(list) => {
            const config = get(list, 'data.0');
            if (!config) return null;

            return <StaticConfigForm config={config as any} />;
          }}
        />
      </List>
    </DashboardContent>
  );
}

export default CustomList;
